"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  d: "M4 6a3 3 0 0 1 3-3h1a4 4 0 0 1 4 4v3a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.075 11.65c-.544.001-1.026-.201-1.368-.568zm0 0c.541-.003 1.02-.207 1.36-.57.336-.359.5-.831.5-1.313V5.056a.7.7 0 1 0-1.4 0v4.71c0 .17-.056.287-.122.357-.06.064-.161.126-.343.126-.182.001-.281-.06-.338-.122a.52.52 0 0 1-.12-.36V5.056a.7.7 0 1 0-1.4 0v4.71c0 .482.16.956.495 1.316m-2.047-.026a.7.7 0 0 0 .7-.7v-5.33a.7.7 0 1 0-1.4 0v5.33a.7.7 0 0 0 .7.7m6.68 0a.7.7 0 0 0 .7-.7v-5.3a.7.7 0 1 0-1.4 0v5.3a.7.7 0 0 0 .7.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.66 5.756a.7.7 0 0 0 .7-.7V4.76c0-.684.64-1.36 1.587-1.36s1.587.676 1.587 1.361v.295a.7.7 0 0 0 1.4 0V4.76C9.934 3.17 8.527 2 6.947 2 5.368 2 3.96 3.17 3.96 4.761v.295a.7.7 0 0 0 .7.7m-.7 4.6C3.96 12.448 5.855 14 8 14s4.04-1.552 4.04-3.644a.7.7 0 1 0-1.4 0c0 1.159-1.097 2.244-2.64 2.244s-2.64-1.085-2.64-2.244a.7.7 0 1 0-1.4 0",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=AttachFileIcon16.js.map